import { Navigate, Routes, Route } from 'react-router-dom'
import { RequireAuth } from './auth/RequireAuth'
import MainLayout from './layouts/MainLayout'
import LoginPage from './pages/Login'
import Dashboard from './pages/Dashboard'
import ProcurementWorkbench from './pages/supply-chain/ProcurementWorkbench'
import PurchaseOrders from './pages/supply-chain/PurchaseOrders'
import PurchaseCreate from './pages/supply-chain/PurchaseCreate'
import PurchaseDetail from './pages/supply-chain/PurchaseDetail'
import PurchaseLogistics from './pages/supply-chain/PurchaseLogistics'
import InventoryList from './pages/supply-chain/InventoryList'
import InventoryLedger from './pages/supply-chain/InventoryLedger'
import InventoryAlert from './pages/supply-chain/InventoryAlert'
import PartsList from './pages/supply-chain/PartsList'
import PartsDetail from './pages/supply-chain/PartsDetail'
import DeviceList from './pages/supply-chain/DeviceList'
import DeviceDetail from './pages/supply-chain/DeviceDetail'
import QuoteList from './pages/sales/QuoteList'
import QuoteDetail from './pages/sales/QuoteDetail'
import NegotiationList from './pages/sales/NegotiationList'
import NegotiationDetail from './pages/sales/NegotiationDetail'
import WorkOrderList from './pages/work-order/WorkOrderList'
import WorkOrderDetail from './pages/work-order/WorkOrderDetail'
import MaintenanceCalendar from './pages/maintenance/MaintenanceCalendar'
import MaintenanceOrderList from './pages/maintenance/MaintenanceOrderList'
import MaintenanceOrderDetail from './pages/maintenance/MaintenanceOrderDetail'
import CustomerList from './pages/customer/CustomerList'
import CustomerDetail from './pages/customer/CustomerDetail'
import EmployeeManagement from './pages/system/EmployeeManagement'
import RoleManagement from './pages/system/RoleManagement'
import PermissionManagement from './pages/system/PermissionManagement'
import DictionaryManagement from './pages/system/DictionaryManagement'
import MedicalDeviceBrandManagement from './pages/basic-information/MedicalDeviceBrandManagement'
import MedicalDeviceCatalogManagement from './pages/basic-information/MedicalDeviceCatalogManagement'
import SupplierManagement from './pages/basic-information/SupplierManagement'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />

          <Route path="supply-chain">
            <Route index element={<Navigate to="purchase/workbench" replace />} />
            <Route path="home" element={<Navigate to="/supply-chain/purchase/workbench" replace />} />

            <Route path="parts">
              <Route index element={<PartsList />} />
              <Route path="list" element={<PartsList />} />
              <Route path=":id" element={<PartsDetail />} />
            </Route>

            <Route path="purchase">
              <Route index element={<Navigate to="workbench" replace />} />
              <Route path="workbench" element={<ProcurementWorkbench />} />
              <Route path="list" element={<PurchaseOrders />} />
              <Route path="create" element={<PurchaseCreate />} />
              <Route path=":id" element={<PurchaseDetail />} />
              <Route path=":id/logistics" element={<PurchaseLogistics />} />
            </Route>

            <Route path="inventory">
              <Route index element={<InventoryList />} />
              <Route path="list" element={<InventoryList />} />
              <Route path="ledger/:id" element={<InventoryLedger />} />
              <Route path="alert" element={<InventoryAlert />} />
            </Route>

            <Route path="device">
              <Route index element={<DeviceList />} />
              <Route path="list" element={<DeviceList />} />
              <Route path=":id" element={<DeviceDetail />} />
            </Route>
          </Route>

          <Route path="work-orders">
            <Route index element={<WorkOrderList />} />
            <Route path=":id" element={<WorkOrderDetail />} />
          </Route>

          <Route path="maintenance/calendar" element={<MaintenanceCalendar />} />

          <Route path="maintenance-orders">
            <Route index element={<MaintenanceOrderList />} />
            <Route path=":id" element={<MaintenanceOrderDetail />} />
          </Route>

          <Route path="customers">
            <Route index element={<CustomerList />} />
            <Route path=":id" element={<CustomerDetail />} />
          </Route>

          <Route path="basic-information">
            <Route index element={<Navigate to="brands" replace />} />
            <Route path="brands" element={<MedicalDeviceBrandManagement />} />
            <Route path="medical-device-catalogs" element={<MedicalDeviceCatalogManagement />} />
            <Route path="suppliers" element={<SupplierManagement />} />
          </Route>

          <Route path="system">
            <Route index element={<Navigate to="employees" replace />} />
            <Route path="employees" element={<EmployeeManagement />} />
            <Route path="roles" element={<RoleManagement />} />
            <Route path="permissions" element={<PermissionManagement />} />
            <Route path="dictionaries" element={<DictionaryManagement />} />
          </Route>

          <Route path="sales">
            <Route index element={<QuoteList />} />
            <Route path="quotes" element={<QuoteList />} />
            <Route path="quotes/:id" element={<QuoteDetail />} />
            <Route path="negotiations" element={<NegotiationList />} />
            <Route path="negotiations/:id" element={<NegotiationDetail />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  )
}
